/**
 * Divider with Heading.
 *
 * @package
 */

/**
 * Internal dependencies.
 */
 import Edit from './edit';
 /**
  * WordPress Dependencies.
  */ 
 import { registerBlockType } from '@wordpress/blocks';
 import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
 import { columns } from '@wordpress/icons'; 
 import { __ } from '@wordpress/i18n';
 /**
  * Register block type.
  */
 registerBlockType( 'ssvreutlingen-blocks/text-column-5', {

	apiVersion: 2,
	 /**
	  * Block title.
	  *
	  * @type {string}
	  */
	 title: __( 'SSV Fünf Spalten Text', 'ssvreutlingen' ),
 
	 /** 
	  * Block icon.
	  *
	  * @type {string}
	  */
	 icon: columns,
	 supports: {
		anchor: true,
		align: ['wide','full'], 
    },
	attributes: {
		align: {
			type: 'string',
			default: 'wide'
		}
	},
	
	 /**
	  * Block description.
	  *
	  * @type {string}
	  */
	 description: __( 'Fünf Spalten Element', 'ssvreutlingen' ),
 
	 /**
	  * Block category.
	  *
	  * @type {string}
	  */
	 category: 'ssvreutlingen',

	 edit: Edit,

 
	 /**
	  * Save function.
	  *
	  * @param {Object} props                    Props
	  *
	  * @param          props.attributes
	  * @param          props.attributes.content
	  * @return {Object} Content.
	  */
	 save() {
		 return (
			<InnerBlocks.Content />
		);
	 },
 } );
 